import { Component, effect, ElementRef, inject, ViewChild } from '@angular/core';
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { HeaderComponent } from './components/header/header.component';
import { RouterOutlet } from "@angular/router";
import { AuthStore } from '@store/auth.facade';
import { ToastComponent } from '@presentation/components/toast/toast.component';
import { SessionTimeoutModalComponent } from '@sharedComponents/session-timeout-modal/session-timeout-modal.component';

@Component({
  selector: 'app-layout',
  imports: [SidenavComponent, HeaderComponent, RouterOutlet, ToastComponent, SessionTimeoutModalComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
  name = '';
  role = '';
  url: string | null = null;
  @ViewChild('sidenavToggle') sidenavToggle!: ElementRef<HTMLInputElement>;

  private readonly authStore = inject(AuthStore);

  constructor() {
    effect(() => {
      const user = this.authStore.user();
      if (user) {
        this.name = user.name || '';
        this.role = user.role?.name || '';
        this.url = user.profileImageUrl ?? null;
      }
    });
  }

  closeSidenav() {
    this.sidenavToggle.nativeElement.click();
  }

}
